/**
 * Application Configuration
 * 
 * This file centralizes all environment-dependent configuration.
 * Values are sourced from environment variables (see .env files).
 * 
 * For local development: Use .env
 * For production: Use .env.production or set environment variables directly
 */

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Application Metadata
export const APP_NAME = process.env.REACT_APP_NAME || 'Neckless Admin Dashboard';
export const APP_VERSION = process.env.REACT_APP_VERSION || '2.0.0';

// Environment Detection
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';
export const isTest = process.env.NODE_ENV === 'test';

// Optional: Third-party Service Configurations
export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

// Validation: Ensure critical environment variables are set in production
if (isProduction && API_BASE_URL.includes('localhost')) {
  console.warn(
    '⚠️ WARNING: API_BASE_URL is set to localhost in production. ' +
    'Please configure REACT_APP_API_BASE_URL in your .env.production file.'
  );
}

// Export all configuration as a single object for easier imports
export const config = {
  apiBaseUrl: API_BASE_URL,
  appName: APP_NAME,
  appVersion: APP_VERSION,
  isDevelopment,
  isProduction,
  isTest,
  googleAnalyticsId: GOOGLE_ANALYTICS_ID,
  sentryDsn: SENTRY_DSN,
} as const;

export default config;
